import { DecisionForm } from "./form";

export function DecisionEdit() {
  return <DecisionForm action="edit" />;
}

export default DecisionEdit;
